import { Link } from 'react-router-dom'
import DropdownUser from './DropdownUser'
import DarkModeSwitcher from './DarkModeSwitcher'
import Logo from '../../../assets/images/logo.png'
import { Select } from 'components/Form'
import { useDispatch, useSelector } from 'react-redux'
import { setUser } from 'store/auth/userSlice'

const Header = props => {
    const dispatch = useDispatch()
    const userInfo = useSelector(state => state.auth.user)

    return (
        <header className="sticky top-0 flex w-full bg-white z-50 drop-shadow-1 dark:bg-boxdark dark:drop-shadow-none border-b-2 border-primary/20">
            <div className="flex items-center justify-between flex-grow px-2 py-2 shadow-3">
                <div className="flex items-center gap-2 lg:hidden">
                    <button
                        aria-controls="sidebar"
                        onClick={e => {
                            e.stopPropagation()
                            props.setSidebarOpen(!props.sidebarOpen)
                        }}
                        className="z-500 flex items-center justify-center rounded-sm border border-stroke bg-white p-2 shadow-sm dark:border-strokedark dark:bg-boxdark"
                    >
                        <svg className="h-5 w-5 text-black dark:text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={props.sidebarOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
                        </svg>
                    </button>
                    <Link to="/dashboard">
                        <h2 className="text-lg font-bold text-black dark:text-white">Quoffee</h2>
                    </Link>
                </div>

                <div className="hidden sm:block"></div>
                <div className="flex items-center gap-3 xsm:gap-4">
                    {userInfo?.branches?.length > 1 && (
                        <Select
                            options={[{ id: '', label: 'All Branches', value: '' }, ...userInfo?.branches]}
                            size="sm"
                            placeholder="All Branches"
                            name="branch"
                            className="hidden min-w-48 sm:block"
                            value={userInfo?.branch?.length > 1 ? '' : userInfo?.branch ? userInfo?.branch[0] : ''}
                            onChange={e => {
                                const user = {
                                    ...userInfo,
                                    branch: e.target.value ? [e.target.value] : userInfo?.branches.map(item => item.id),
                                }
                                dispatch(setUser(user))
                            }}
                        />
                    )}
                    <ul className="flex items-center gap-2 xsm:gap-4">
                        <DarkModeSwitcher />
                    </ul>

                    {/* <!-- User Area --> */}
                    <DropdownUser />
                    {/* <!-- User Area --> */}
                </div>
            </div>
        </header>
    )
}

export default Header
